module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/_redefine.js
// module id = 1687
// module chunks = 0